import React, { Component, Fragment } from "react";
import userService from "../../../services/userService";
import "../../../resources/profile.css";
import CircularLoadingScreen from "../../commons/CircularLoadingScreen";
import PostList from "../PostList";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import postService from "../../../services/postService";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { TextField } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import FieldLengthLabel from "../../commons/FieldLengthLabel";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import defaultProfilePic from "../../../resources/images/defaultProfilePic.png";
import defaultBannerPic from "../../../resources/images/defaultBannerPic.png";
import NotFound from "../../NotFound";
import BlockIcon from "@mui/icons-material/Block";
import { withSnackbar } from "../../../hocs/withSnackbar";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";

import { Route, Switch, Redirect } from "react-router-dom";
import ProfilePosts from "./ProfilePosts";
import ProfileFollowers from "./ProfileFollowers";

import { Tab, Tabs } from "@mui/material";
import { withRouter } from "react-router-dom";

const textFieldStyles = {
  InputProps: {
    style: {
      fontFamily: "inherit",
    },
  },
  InputLabelProps: {
    style: {
      fontFamily: "inherit",
    },
  },
};

class Profile extends Component {
  state = {
    userDoesExist: true,
    loadedUserProfile: false,
    userDetails: {},
    isEditing: false,
    editingResultLoading: false,
    editingError: "",
    profileOptionsElement: null,
    data: {
      profilePic: "",
      profilePicUrl: "",
      deletePic: false,
      bannerPic: "",
      bannerPicUrl: "",
      deleteBanner: false,
      bio: "",
    },
  };

  async componentDidMount() {
    await this.loadUserDetails();
  }

  handleOptionsClick = (event) => {
    this.setState({
      profileOptionsElement: event.currentTarget,
    });
  };

  handleOptionsClose = () => {
    this.setState({
      profileOptionsElement: null,
    });
  };

  handleFileChange = ({ currentTarget: input }, urlProp, deleteProp) => {
    const fileMaxSize = process.env.REACT_APP_FILE_MAX_SIZE;
    if (input.files[0].size <= fileMaxSize) {
      const data = { ...this.state.data };
      data[input.name] = input.files[0];
      data[urlProp] = URL.createObjectURL(input.files[0]);
      data[deleteProp] = false;
      this.setState({
        data,
        editingError: "",
      });
    } else {
      this.setState({
        editingError: "File must be smaller than 5MB",
      });
    }
  };

  handleChange = ({ currentTarget: input }) => {
    const data = { ...this.state.data };
    data[input.name] = input.value;
    this.setState({
      data,
    });
  };

  startLoading() {
    this.setState({
      editingResultLoading: true,
    });
  }

  finishLoading() {
    this.setState({
      editingResultLoading: false,
    });
  }

  saveUserDetails = async () => {
    this.startLoading();
    const { profilePic, bannerPic, deletePic, deleteBanner, bio } =
      this.state.data;
    try {
      const response = await userService.updateUserDetails(
        profilePic,
        bannerPic,
        deletePic,
        deleteBanner,
        bio
      );
      this.finishLoading();
      this.revert();
      await this.loadUserDetails();
      this.setState({ isEditing: false });
    } catch (error) {
      this.finishLoading();
      if (error.response) {
        this.setState({
          editingError: error.response.data.message,
        });
      }
    }
  };

  loadUserDetails = async () => {
    const username = this.props.match.params.name;
    try {
      const response = await userService.getUserDetails(username);
      const userDetails = response.data.data;
      const data = { ...this.state.data };
      data.bio = userDetails.bio || "";
      this.setState({
        loadedUserProfile: true,
        userDetails,
        data,
      });
    } catch (error) {
      if (error.response) {
        if (error.response.status == 404) {
          this.setState({
            userDoesExist: false,
          });
        }
      }
    }
  };

  deletePicture = (prop) => {
    const data = { ...this.state.data };
    data[prop] = true;
    this.setState({
      data,
    });
  };

  revert = () => {
    this.setState({
      data: {
        profilePic: "",
        profilePicUrl: "",
        banner: "",
        bio: this.state.userDetails.bio || "",
      },
    });
  };

  toggleFollow = async () => {
    try{

      const username = this.props.match.params.name;
      const response = await userService.followUser(username);
      const { state, count } = response.data.data;
      const userDetails = { ...this.state.userDetails };
      userDetails.following = state;
      userDetails.followers = count;
      this.setState({
        userDetails,
      });
    }catch(err){
      if(err.response){
        const errorMessage = err.response.data.message
        if(errorMessage){
          this.props.showMessage(errorMessage, "error")
        }
      } else {
        this.props.showMessage("Failed to toggle like: an error occurred", "error")
      }
    }
  };

  toggleBan = async () => {
    try {
      const { userDetails } = this.state;
      const response = await userService.toggleUserBan(userDetails.username);
      const isBlocked = response.data.data;
      this.props.showMessage((isBlocked ? "Blocked" : "Unblocked") + " user");
      await this.loadUserDetails();
    } catch (error) {
      if (error.response) {
        this.props.showMessage(error.response.data.message, "error");
      }
    }
  };

  render() {
    const {
      loadedUserProfile,
      userDetails,
      isEditing,
      editingError,
      editingResultLoading,
      data,
      userDoesExist,
      profileOptionsElement,
    } = this.state;

    const profileOptionsOpen = !!profileOptionsElement;

    const {
      admin: isAdmin,
      banned: isBanned,
      id,
      bio,
      username,
      following,
      followers,
      posts,
    } = userDetails;
    const {
      profilePicUrl,
      bio: dataBio,
      bannerPicUrl,
      deleteBanner,
      deletePic,
    } = data;

    const { history } = this.props;

    if (!userDoesExist) {
      return <NotFound />;
    }

    if (!loadedUserProfile) {
      return (
        <Fragment>
          <CircularLoadingScreen thickness={5} />
        </Fragment>
      );
    }
    const currentUser = userService.getCurrentUser();
    const backendApiPath = process.env.REACT_APP_BACKEND_API_PATH;
    const bioMaxLen = process.env.REACT_APP_PROFILE_BIO_MAXLEN;

    return (
      <Fragment>
        <div className="profile">
          {!loadedUserProfile ? (
            <CircularLoadingScreen thickness={5} />
          ) : (
            <Fragment>
              <div className="banner">
                {!isEditing ? (
                  <Fragment>
                    <img src={backendApiPath + `/profile/${username}/banner`} />
                  </Fragment>
                ) : (
                  <Fragment>
                    <DeleteOutlineIcon
                      className="delete-icon"
                      onClick={() => this.deletePicture("deleteBanner")}
                    />
                    <img
                      src={(() => {
                        if (deleteBanner) {
                          return defaultBannerPic;
                        }
                        return bannerPicUrl
                          ? bannerPicUrl
                          : backendApiPath + `/profile/${username}/banner`;
                      })()}
                      height="150"
                      width="600"
                    />
                    <input
                      id="banner-pic-input"
                      type="file"
                      name="bannerPic"
                      accept="image/png, image/gif, image/jpeg"
                      onChange={(e) =>
                        this.handleFileChange(e, "bannerPicUrl", "deleteBanner")
                      }
                    />
                    <label htmlFor="banner-pic-input" className="edit-layer">
                      CHANGE
                      <br />
                      BANNER
                    </label>
                  </Fragment>
                )}
              </div>
              <div style={{ display: "flex" }}>
                <div className="img-container">
                  {!isEditing ? (
                    <img src={backendApiPath + `/profile/${username}/pic`} />
                  ) : (
                    <Fragment>
                      <DeleteOutlineIcon
                        className="delete-icon"
                        onClick={() => this.deletePicture("deletePic")}
                      />
                      <img
                        src={(() => {
                          if (deletePic) {
                            return defaultProfilePic;
                          }
                          return profilePicUrl
                            ? profilePicUrl
                            : backendApiPath + `/profile/${username}/pic`;
                        })()}
                        width="100"
                        height="100"
                      />

                      <input
                        id="profile-pic-input"
                        type="file"
                        name="profilePic"
                        accept="image/png, image/gif, image/jpeg"
                        onChange={(e) =>
                          this.handleFileChange(e, "profilePicUrl", "deletePic")
                        }
                      />
                      <label htmlFor="profile-pic-input" className="edit-layer">
                        CHANGE
                        <br />
                        IMAGE
                      </label>
                    </Fragment>
                  )}
                </div>
                {isEditing && (
                  <div
                    style={{
                      padding: 10,
                      boxSizing: "border-box",
                      fontSize: 14,
                      color: "grey",
                    }}
                  >
                    Profile picture: 100x100. Banner: 600x150.
                    <br />
                    Max file size: 5MB. Supports .png, .jpg &amp; .gif
                  </div>
                )}
              </div>
              <div className="profile-data">
                {!isEditing ? (
                  <Fragment>
                    <div id="profile-options">
                      {currentUser.sub != username && (
                        <Button
                          variant={following ? "outlined" : "contained"}
                          onClick={() => this.toggleFollow()}
                        >
                          {following ? "Unfollow" : "Follow"}
                        </Button>
                      )}
                      <IconButton
                        aria-controls={
                          profileOptionsOpen ? "basic-menu" : undefined
                        }
                        aria-haspopup="true"
                        aria-expanded={profileOptionsOpen ? "true" : undefined}
                        onClick={this.handleOptionsClick}
                        style={{
                          marginLeft: 20,
                        }}
                      >
                        <MoreVertIcon />
                      </IconButton>
                      <Menu
                        anchorEl={profileOptionsElement}
                        open={profileOptionsOpen}
                        onClose={this.handleOptionsClose}
                        MenuListProps={{
                          "aria-labelledby": "basic-button",
                        }}
                      >
                        {currentUser.sub == username && (
                          <MenuItem
                            style={{
                              fontFamily: "inherit",
                            }}
                            onClick={() => {
                              this.handleOptionsClose();
                              this.setState({ isEditing: true });
                            }}
                          >
                            <ListItemIcon>
                              <EditOutlinedIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText
                              primaryTypographyProps={{
                                style: {
                                  fontFamily: "inherit",
                                },
                              }}
                            >
                              Edit
                            </ListItemText>
                          </MenuItem>
                        )}
                        {currentUser.isAdmin && currentUser.sub != username && (
                          <MenuItem
                            onClick={() => {
                              this.toggleBan();
                              this.handleOptionsClose();
                            }}
                            style={{
                              fontFamily: "inherit",
                            }}
                          >
                            <ListItemIcon>
                              <BlockIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText
                              primaryTypographyProps={{
                                style: {
                                  fontFamily: "inherit",
                                },
                              }}
                            >
                              {isBanned ? "Unblock" : "Block"}
                            </ListItemText>
                          </MenuItem>
                        )}
                      </Menu>
                    </div>

                    <h2 className="heading" id="profile-username">
                      {username}
                      {isBanned && (
                        <Tooltip
                          title={
                            <span
                              style={{ fontSize: 14, fontFamily: "inherit" }}
                            >
                              This user is blocked
                            </span>
                          }
                          placement="top"
                          arrow
                        >
                          <IconButton>
                            <BlockIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                      {isAdmin && (
                        <Tooltip
                          title={
                            <span
                              style={{ fontSize: 14, fontFamily: "inherit" }}
                            >
                              Administrator
                            </span>
                          }
                          placement="top"
                          arrow
                        >
                          <IconButton>
                            <ShieldOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                    </h2>
                    <p id="profile-bio">
                      {bio || (
                        <Fragment>
                          <i>This user has no bio. Scary.</i>
                        </Fragment>
                      )}
                    </p>
                    <div className="stats">
                      <div className="stat">
                        <b>{posts}</b> post{posts != 1 && 's'}
                      </div>
                      <div className="stat">
                        <b>{followers}</b> follower{followers != 1 && 's'}
                      </div>
                    </div>
                  </Fragment>
                ) : (
                  <Fragment>
                    <div className="profile-data-edit">
                      <TextField
                        rows={2}
                        multiline
                        variant="filled"
                        fullWidth
                        label="Bio"
                        {...textFieldStyles}
                        inputProps={{ maxLength: bioMaxLen }}
                        name="bio"
                        value={dataBio}
                        onChange={this.handleChange}
                      />
                      <FieldLengthLabel
                        length={dataBio.length}
                        maxLength={bioMaxLen}
                      />
                      <div
                        className="footer"
                        style={
                          editingError
                            ? {
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }
                            : {}
                        }
                      >
                        {editingError && (
                          <div className="alert">{editingError}</div>
                        )}
                        <div style={{ display: "flex" }}>
                          <Button
                            style={{ fontFamily: "inherit", marginRight: 10 }}
                            onClick={() => {
                              this.revert();
                              this.setState({ isEditing: false });
                            }}
                          >
                            cancel
                          </Button>
                          <LoadingButton
                            variant="contained"
                            style={
                              !editingResultLoading
                                ? {
                                    fontFamily: "inherit",
                                    backgroundColor: "var(--theme-orange)",
                                  }
                                : {
                                    fontFamily: "inherit",
                                  }
                            }
                            onClick={this.saveUserDetails}
                            loading={editingResultLoading}
                            loadingPosition="start"
                            startIcon={<SaveIcon />}
                            disabled={editingResultLoading}
                          >
                            Save
                          </LoadingButton>
                        </div>
                      </div>
                    </div>
                  </Fragment>
                )}
              </div>
            </Fragment>
          )}
        </div>
        <div style={{
          marginTop: 20
        }}>
          <Tabs
            value={history.location.pathname}
            onChange={(event, newValue) => {
              history.push(newValue);
            }}
            variant="fullWidth"
            style={{
              fontFamily: "inherit",
            }}
          >
            <Tab
              label="Posts"
              value={`/profile/${username}`}
              className="profile-tab"
            />
            <Tab
              label="Followers"
              value={`/profile/${username}/followers`}
              className="profile-tab"
            />
          </Tabs>
        </div>
        <div className="posts">
          <Fragment>
            <Switch>
              <Route
                path="/profile/:name/followers"
                exact
                component={ProfileFollowers}
              />
              <Route path="/profile/:name" exact component={ProfilePosts} />
              <Redirect from="/" to={`/profile/${username}`} />
            </Switch>
          </Fragment>
        </div>
      </Fragment>
    );
  }
}

export default withRouter(withSnackbar(Profile));
